export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الحالة"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الموقع"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معرف المتجر"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات المتجر"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رابط الدفع"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نشط"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["غير نشط"])}
}